// extracted by mini-css-extract-plugin
export default {"textAreaBox":"TextArea_textAreaBox__vyGni","labelDisabled":"TextArea_labelDisabled__C2Y8T"};